export const getAssets = (state) => {
    return state.assets;
  }